import { makeStyles, tokens } from '@fluentui/react-components';

const baseGridStyle = {
  display: 'grid',
  gap: tokens.spacingHorizontalSNudge,
};

export const useHealthTrackerStyles = makeStyles({
  grid: {
    ...baseGridStyle,
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
  gridMobile: {
    ...baseGridStyle,
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
});
